import MainContent from "../../components/maincontent";
import ChangePassword from "../../pages/auth/login/changePassword";
import ForgotPage from "../../pages/auth/login/forgotPage";
import Dashboard from "../../pages/user/dashboard";
import ResponseUi from "../../pages/user/responseui";
import Chats from "../../pages/user/chats";
import Layout from "../navLayout";

export const publicRoutes = [
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: <Dashboard />,
            },
            {
                path: "/newquery",
                element: <MainContent />,
            },
            {
                path: "/chats",
                element: <Chats />,
            },
            {
                path: "/response",
                element: <ResponseUi />,
            },
            {
                path: "*",
                element: <Dashboard />,
            },
        ],
    },
    {
        path: `/changePassword`,
        element: <ChangePassword />,
    },
    {
        path: "/forgotPassword",
        element: <ForgotPage />,
    },
];
